<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-8 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('location.Location_info')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="goToStep(0)">
                                                {{ $t('location.Location_info') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('location.Contact_address_details')"
                                                :class="activeStep >= 1 ? activeClass : ''" @click="goToStep(1)">
                                                {{ $t('location.Contact_address_details') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('location.RVO')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="goToStep(2)">
                                                {{ $t('location.RVO') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('location.Toiler_disease_free')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="goToStep(3)">
                                                {{ $t('location.Toiler_disease_free') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('location.Scrapie')"
                                                :class="activeStep >= 4 ? activeClass : ''" @click="goToStep(4)">
                                                {{ $t('location.Scrapie') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <location-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"
                                            @update:formData="updateFormData"
                                        />
                                        <Address 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <rvo 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <toiler 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                             
                                            @update:formData="updateFormData"
                                        />
                                        <scrapie 
                                            v-if="activeStep === 4" 
                                            :class="activeStep === 4 ? activeClass : ''"
                                            :formData="formData"                                                                                         
                                            :emitter="emitter"                                            
                                        />                                        
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 4" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import * as Choices from "choices.js";
import LocationInfo from "./components/LocationInfo.vue";
import Address from "./components/Address.vue";
import Rvo from "./components/Rvo.vue";
import Toiler from "./components/Toiler.vue";
import Scrapie from "./components/Scrapie.vue";
import mitt from 'mitt';

    export default {
        name: 'Location_create_page',
        data() {
            return {
                emitter: mitt(),
                activeStep: 0,
                activeClass: "js-active position-relative",
                formSteps: 5,
                formData: {
                    ubn: '',
                    name: '',
                    locationTypeId: '',                    
                    keeperId: '',
                    maxAnimalCapacity: null,
                    animalTypeId: [],

                    phoneNumber: '',
                    email: '',
                    street: '',
                    houseNumber: '',
                    place: '',
                    postalCode: '',
                    country: 'Nederland',	
                    latitude: '',
                    longitude: '',

                    isRvoVerified: false,
                    rvoVerificationDate: null,      //When verification was completed
                    rvoVerifier: '',                //Name or ID of the verifier (internal or external)
                    rvoVerificationMethod: '',      //Method used (API sync, manual entry, certificate)
                    rvoVerificationSource: '',      //Source system (e.g., RVO API, uploaded doc)
                    rvoCertificateNumber: '',       //If applicable: a certificate or UBN document number
                    rvoVerificationNotes: '',       //Any additional notes or comments from verifier

                    isToilerDiseaseFree: false,         //-- Toiler Disease-Free  
                    toilerDiseaseLastCheckDate: null,   //Last date of Toiler disease check
                    toilerDiseaseCheckMethod: '',       //Method of Toiler disease check (e.g., blood test)
                    toilerNotes: '',                    //Any additional notes
                    toilerCertificateFilePath: '',      //Path to uploaded Toiler certificate


                    hasScrapieCertificate: false,          //-- Scrapie Certificate
                    scrapieCertificateNumber: '',          //-- Certificate number
                    scrapieCertificateIssuedDate: null,    //When the certificate was issued
                    scrapieCertificateExpiryDate: null,    //When the certificate expires
                    scrapieIssuedBy: '',                   //Who issued the certificate (e.g., RVO)
                    scrapieVerifiedBy: '',                 //Who verified it (system or user)
                    isScrapieCertificateVerified: false,          
                    scrapieNotes: '',                      //Any notes related to scrapie status
                    scrapieCertificateFilePath: '',        //Path to uploaded Scrapie certificate  
                    
                    locationTypes:[],
                    keepers:[],
                    animalTypes: []
                },
                choicesInstance: null,
                choicesInstanceLocationType: null
            };
        },
        components: {
            LocationInfo,            
            Address,
            Rvo,
            Toiler,
            Scrapie
        },    
        async mounted() {              
        },
        methods: {            
            initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
                const element = document.getElementById(id);
                if (!element || element.tagName !== "SELECT") {
                    console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                    return;
                }

                // Destroy previous instance if it exists
                if (this[instanceKey]) {
                    this[instanceKey].destroy();
                }

                // Initialize new Choices instance
                this[instanceKey] = new Choices(element, {
                    searchEnabled: true,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: true,
                });

                // Set selected value if it exists in list
                if (selectedValue) {
                    const optionExists = dataList.some(item => item.id === selectedValue);
                    this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
                }
            },
            goToStep(step) {
                if (step <= this.activeStep) {
                this.activeStep = step;
                }
            },       
            async nextStep() {                
                if (this.activeStep < this.formSteps -1) {
                    this.activeStep += 1;
                    //console.log(this.activeStep);
                } else {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);
                }   
            },
            async prevStep() {
                if (this.activeStep > 0) {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);
                }
            },
            updateFormData(updatedData) {
                this.formData = { ...this.formData, ...updatedData };                
            },            
            async saveForm() {
                this.submitForm();
            }, 
            async submitForm() {                
                // Put create logic
                try {
                    
                    this.$store.commit('setShowLoading', true);

                    console.log('DEBUG: formData =', this.formData);

                    // Create a FormData object
                    const formData = new FormData();

                    // Append form data fields
                    Object.keys(this.formData).forEach(key => {
                        const value = this.formData[key];

                        if (key === 'keepers') return;
                        if (key === 'locationTypes') return;
                        if (key === 'animalTypes') return;
                        if (key === 'scrapieCertificateFilePath') return;
                        if (key === 'toilerCertificateFilePath') return;
                        if (key === 'associationId') return;
                        
                        const isDateField = ['rvoVerificationDate', 'toilerDiseaseLastCheckDate', 'scrapieCertificateIssuedDate', 'scrapieCertificateExpiryDate'];
                        if (isDateField.includes(key) && value instanceof Date) {
                            formData.append(key, value.toISOString().split('T')[0]);
                        } else if (value instanceof File) {
                            // Append actual file upload
                            formData.append(key, value, value.name);
                        } else if (value !== null && value !== undefined) {
                            formData.append(key, value);
                        }
                    });

                    formData.append("isActive", true); // By default it is true

                    if (this.$route.params.id) {
                        formData.append("associationId", this.$route.params.id);
                    }

                    // Debug: log the formData contents
                    for (let [key, value] of formData.entries()) {
                        console.log(`${key}:`, value);
                    }

                    // Now send formData as part of your request
                    await axios.post('/Location/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }) 
                    .then(response => {
                        // Handle success
                        //console.log('Form saved successfully', response.data);
                        this.gets = response.data;
                        if (this.gets.success) {  
                            this.$showSuccess('errors.Success_location_created_successfully');                          
                            
                            this.$router.push('/location');
                        } else {
                            this.$showError('errors.Contact_system_admin');
                        }
                    });                    
                }
                catch(e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            }
        },
    }
</script>

<style>



.choices[data-type*=select-one]::after {
  display: none !important;
}


.choices__inner {
    display: grid !important;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}


.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>

